
import { Link } from 'react-router-dom';
import { CardInfo } from 'types/gameInfo';
import { sanitizeURIPathSegment, sanitizeURISlug } from 'helpers/routing';
import { LINK } from 'components/styles';

interface CardLinkProps {
  cardInfo: CardInfo | null;
  cardName: string;
  onClick?: any;
}

const CardLink = ({cardInfo, cardName, onClick = null} : CardLinkProps) => {
  if (!cardInfo?.gameCode && !cardInfo?.setName && !cardInfo?.number) {
    return <>{cardName}</>;
  }

  return (
    <Link to={`/${cardInfo.gameCode}/${sanitizeURIPathSegment(cardInfo.setName)}/${sanitizeURISlug(cardInfo.number)}`} onClick={onClick} className={LINK}>{cardName}</Link>
  )
}

export default CardLink;